import {KTIcon} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'

const UserEditModalHeader = ({user}) => {
  const {setItemIdForUpdate, modalType, setIsModalType} = useListView()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>{modalType === 'EDIT' ? `Edit Review For Booking ID #${user?.booking_id}` : modalType === 'DELETE' ? `Delete Review For Booking ID #${user?.booking_id}` : ''}</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() =>  {
          setItemIdForUpdate(undefined)
          setIsModalType("")
        }}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {UserEditModalHeader}
